import none from "~/kernel/arrays/none";
import sortBy from "~/kernel/arrays/sortBy";
import type { FakeLocalServiceGroup } from "~/service/components/SortServicesFormFields/LocalServiceGroup";
import type LocalServiceGroup from "~/service/components/SortServicesFormFields/LocalServiceGroup";
import isNil from "~/kernel/validation/isNil";
import type { Service } from "../models/Service";

export const DEFAULT_GROUP: FakeLocalServiceGroup & {
  services: Service[];
  index: number;
} = {
  id: null,
  type: "fake",
  name: "Övrigt",
  sortOrder: 0,
  services: [],
  index: 0,
};

export default function groupServices<
  TGroup extends Pick<LocalServiceGroup, "id" | "sortOrder">,
  TService extends Pick<Service, "groupId" | "sortOrder">,
>(services: TService[], groups: TGroup[]) {
  const getOrder = (x: Pick<Service, "sortOrder">) => x.sortOrder;
  const groupDoesNotExist = (groupId: string | null) => {
    return none(groups, (g) => g.id === groupId);
  };
  const servicesWithoutGroups = services.filter(
    (s) => isNil(s.groupId) || groupDoesNotExist(s.groupId),
  );

  return [
    ...sortBy(groups, getOrder).map((group) => {
      return {
        ...group,
        services: sortBy(services, getOrder).filter(
          (s) => s.groupId === group.id,
        ),
      };
    }),
    ...(servicesWithoutGroups.length > 0
      ? [
          {
            ...DEFAULT_GROUP,
            services: services.filter(
              (s) => isNil(s.groupId) || groupDoesNotExist(s.groupId),
            ),
          },
        ]
      : []),
  ];
}
